import { render, staticRenderFns } from "./NoServiceGranted.vue?vue&type=template&id=333dd91d"
import script from "./NoServiceGranted.vue?vue&type=script&lang=js"
export * from "./NoServiceGranted.vue?vue&type=script&lang=js"
import style0 from "./NoServiceGranted.vue?vue&type=style&index=0&id=333dd91d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports